import { Button, styled } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { ComponentProps, FC } from 'react'
import { requiresUserLoggedIn } from '../../../__legacy__/components/AuthFlow/AuthFlowModal'

const StyledCollectButton = styled(Button, { width: '100%', color: 'white', marginTop: '12px' })

export const CollectButton: FC<ComponentProps<typeof Button>> = observer((props) => (
  <>
    {requiresUserLoggedIn(
      <StyledCollectButton variant="success" size="sm" {...props}>
        {props.children}
      </StyledCollectButton>
    )}
  </>
))
